import { auth, storage, usersCollection, contactsCollection, messagesCollection, numToUidCollection } from "./firebaseConfig"
import { logEntry } from './logEntryFile';

export default async function deleteAccount(uid, logCallback) {
    
    console.log('hello')

    const userModel = await usersCollection.child(uid).once('value');
    const contacts = userModel.val().contacts;
    const phoneNumber = userModel.val().phone;

    await deleteContacts(contacts, logCallback);
    await deleteMessages(phoneNumber, logCallback);
    await deleteNumberFromTwilio(phoneNumber, logCallback);
    await deleteUserImagesFiles(uid, logCallback);
    await deleteUserModel(uid, logCallback);
    await deleteUserAuth(uid, logCallback);
    
    console.log('%caccount should be deleted!', 'color: green');
    logCallback(logEntry("Account Deleted!", "green"))
}


async function deleteContacts(contacts, logCallback) {

    if (contacts == null) {
        console.log('no contacts!')
        logCallback(logEntry('No contacts!', "grey"))
        return Promise.resolve()
    }

    console.log('deleting contacts...')    
    logCallback(logEntry('deleting contacts...', "black"))

    const contactIds = Object.keys(contacts);
    const contactPromises = contactIds.map(contactId => {

        return contactsCollection.child(contactId).remove() // LIVE: change to remove()
        .then(() => {
            console.log('successfully deleted contact: ' + contactId);
            logCallback(logEntry('successfully deleted contact: ' + contactId, "black"))
        })
        .catch(error => {
            console.log('%cerror deleting contact ' + contactId + ' from database', 'color: red')
            logCallback(logEntry('error deleting contact ' + contactId + ' from database', "red"))
            console.log(error);
        })
    })

    return Promise.all(contactPromises).then(() => {
        console.log('%ccontacts deleted from database!', 'color: green')
        logCallback(logEntry('contacts deleted from database!', "green"))
    })
}

async function deleteMessages(phoneNumber, logCallback) {

    if (phoneNumber == null) {
        console.log('no number, so no messages!')
        logCallback(logEntry('no number, so no messages either!', "gray"))
        return Promise.resolve()
    }

    const messagesModel = await messagesCollection.child(phoneNumber).once('value');

    if (!messagesModel.exists()) {
        console.log('no messages!')
        logCallback(logEntry('no messages!', "gray"))
        return Promise.resolve()
    }

    console.log('deleting messages...')
    logCallback(logEntry('deleting messages...', "black"))

    const messagesRecipArray = Object.values(messagesModel.val());

    const messages = messagesRecipArray.reduce((prev, currVal) => {

        const messageValues = Object.values(currVal)
        return messageValues.concat(prev)

    }, [])

    const pictureMessages = messages.filter(message => {
        return (message.imageUrl != null)
    })

    const audioMessages = messages.filter(message => {
        return (message.audioUrl != null && !message.audioUrl.startsWith('-'))
    })

    console.log(pictureMessages);
    console.log(audioMessages);

    console.log('deleting picture messages from storage...');
    logCallback(logEntry('deleting picture messages from storage...', "black"))
    await deletePictureMessages(pictureMessages, logCallback);
    console.log('%cdeleted picture messages from storage!', 'color: green');
    logCallback(logEntry('deleted picture messages from storage!', "green"))

    console.log('deleting audio messages from storage...');
    logCallback(logEntry('deleting audio messages from storage...', "black"))
    await deleteAudioMessages(audioMessages, logCallback);
    console.log('%cdeleted audio messages from storage!', 'color: green');
    logCallback(logEntry('deleted audio messages from storage!', "green"))

    console.log('deleting messages from database...')
    logCallback(logEntry('deleting messages from database...', "black"))
    return messagesCollection.child(phoneNumber).remove() // LIVE: change to remove()
    .then(() => {
        console.log('%cmessages deleted from database!', 'color: green');
        logCallback(logEntry('messages deleted from database!', "green"))
    })
    .catch(error => {
        
        console.log('%cerror deleting messages from database:', 'color: red');
        logCallback(logEntry('messages deleted from database!', "green"))
        console.log(error);
    })
}

async function deleteUserAuth(uid, logCallback) {

    console.log('deleting user from Auth...');
    logCallback(logEntry('deleting user from Auth...', "black"))

    const deleteUserURL = 'https://old.ohanaisfamily.com/api/deleteUser';

    const body = {
        uid: uid
    }

    const axios =  require('axios');

    return axios.post(deleteUserURL, body)
    .then(response => {

        if (response.data.success) {
            console.log('%cuser ' + uid + ' successfully deleted from Auth!', 'color: green');
            logCallback(logEntry('user ' + uid + ' successfully deleted from Auth!', "green"))
        } else {
            console.log('%cERROR! something went wrong trying to delete user from Auth here is returned response:', 'color: red')
            logCallback(logEntry('ERROR! something went wrong trying to delete user from Auth', "red"))
            console.log(response);
        }
    })
    .catch(error => {
        console.log('%cAxios got error trying to delete User from Auth:', 'color: red');
        logCallback(logEntry('Axios got error trying to delete User from Auth', "red"))
        console.log(error);
    })
}

async function deleteUserModel(uid, logCallback) {
    
    console.log('deleting user model from DB...');
    logCallback(logEntry('deleting user model from DB...', "black"))

    return usersCollection.child(uid).remove() // LIVE: change to remove()
    .then(() => {
        console.log('%cdeleted User model from DB!', 'color: green');
        logCallback(logEntry('deleted User model from DB!', "green"))
    })
    .catch(error => {
        console.log('%cerror deleting User model from DB:', 'color: red');
        logCallback(logEntry('error deleting User model from DB', "red"))
        console.log(error);
    })
}

async function deleteUserImagesFiles(uid, logCallback) {

    const storageRef = storage.ref('UserImages/' + uid);

    const fileRefs = await storageRef.listAll()
    .then(result => {
        return result.items;
    })
    .catch(error => {
        console.log('%cerror getting storage folder content refs for: ' + storageRef.fullPath, 'color: red');
        logCallback(logEntry('error getting storage folder content refs for: ' + storageRef.fullPath, "red"))
        console.log(error);
    })

    const deletePromises = fileRefs.map(ref => {
        return ref.delete() // LIVE: change to delete()
        .then(() => {
            console.log('successfully deleted UserImages file: ' + ref.fullPath);
            logCallback(logEntry('successfully deleted UserImages file: ' + ref.fullPath, "green"))
        })
        .catch(error => {
            console.log('%cerror deleting UserImages file from Storage:', 'color: red');
            logCallback(logEntry('error deleting UserImages file from Storage', "red"))
            console.log(storageRef.fullPath);
            console.log(error);
        })
    })

    return Promise.all(deletePromises).then(() => {
        console.log('%cdeleted all files from user Storage folder: ' + storageRef.fullPath, 'color: green');
        logCallback(logEntry('deleted all files from user Storage folder: ' + storageRef.fullPath, "green"))
    });
}

async function deleteNumberFromTwilio(phoneNumber, logCallback) {

    if (phoneNumber == null) {
        console.log('no number to delete from Twilio!')
        logCallback(logEntry('no number to delete from Twilio!', "gray"))
        return Promise.resolve()
    }

    console.log('deleting number delete request to Twilio...');
    logCallback(logEntry('deleting number delete request to Twilio...', "black"))

    const deleteNumberURL = 'https://old.ohanaisfamily.com/api/deleteNumber';

    const body = {
        phoneNumber: phoneNumber // LIVE: change this to phoneNumber: phoneNumber
    }

    const axios =  require('axios');

    await axios.post(deleteNumberURL, body)
    .then(response => {

        if (response.data.success) {
            console.log('%cnumber ' + phoneNumber + ' successfully deleted from Twilio!', 'color: green');
            logCallback(logEntry('number ' + phoneNumber + ' successfully deleted from Twilio!', "green"))
        } else {
            console.log('%cERROR! something went wrong trying to delete number, check Twilio... here is returned response', 'color: red');
            logCallback(logEntry('ERROR! something went wrong trying to delete number, check Twilio...', "red"))
            console.log(response);
        }
    })
    .catch(error => {
        console.log('%cgot error trying to deleteNumber:', 'color: red');
        logCallback(logEntry('got error trying to deleteNumber', "red"))
        console.log(error);
    })

    return numToUidCollection.child(phoneNumber).remove() // LIVE: change to remove()
    .then(() => {
        console.log('%cdeleted NumberToUid entry!', 'color: green');
        logCallback(logEntry('deleted NumberToUid entry!', "green"))
    })
    .catch(error => {
        console.log('%cerror deleting NumberToUid entry:', 'color: red');
        logCallback(logEntry('error deleting NumberToUid entry', "red"))
        console.log(error);
    })
}





async function deleteAudioMessages(audioMessages, logCallback) {

    const audioUrls = audioMessages.map(message => {
        return message.audioUrl;
    })

    const storageRefs = audioUrls.map(url => {
        return storage.refFromURL(url);
    })

    const deletePromises = storageRefs.map(ref => {
        return ref.delete() // LIVE: change to delete()
        .then(() => {
            console.log('successfully deleted audio message: ' + ref.fullPath);
            logCallback(logEntry('successfully deleted audio message: ' + ref.fullPath, "black"))
        })
        .catch(error => {
            console.log('%cerror deleting audio message:', 'color: red');
            logCallback(logEntry('error deleting audio message: ' + ref.fullPath, "red"))
            console.log(ref.fullPath);
            console.log(error);
        })
    })

    return Promise.all(deletePromises);
}

async function deletePictureMessages(pictureMessages, logCallback) {

    const imageFilenames = pictureMessages.map(message => {
        return message.imageUrl;
    })

    const storageRefs = imageFilenames.map(filename => {
        return storage.ref('MessageAttachments/' + filename);
    })

    const deletePromises = storageRefs.map(ref => {
        return ref.delete() // LIVE: change to delete()
        .then(() => {
            console.log('successfully deleted picture message: ' + ref.fullPath);
            logCallback(logEntry('successfully deleted picture message: ' + ref.fullPath, "black"))
        })
        .catch(error => {
            console.log('%cerror deleting picture message:', 'color: red');
            logCallback(logEntry('error deleting picture message: ' + ref.fullPath, "red"))

            console.log(ref.fullPath);
            console.log(error);
        })
    })

    return Promise.all(deletePromises);
}



// WEBPACK FOOTER //
// ./src/tools/deleteAccount.js